import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TeamShortModal } from "app/components/modals";
import { CONSTANTS } from "app/constants";
import { DrawingFixtureDto, DrawingWCPlayoffResponseDto } from "app/models";
import { DrawingsService, NotificationService } from "app/services";

@Component({
    selector: 'drawing-cwc-playoff',
    templateUrl: './drawing-cwc-playoff.component.html',
    styleUrls: ['./drawing-cwc-playoff.component.scss'],
})
export class DrawingClubWCPlayOff implements OnInit {
    
    @Input()
    stage: number;
    
    stages: any[];

    const;

    matchDay1: number;

    drawingResult: DrawingFixtureDto[];

    isLoading: boolean = false;

    constructor(private drawingService: DrawingsService, private notificationService: NotificationService,
        private modalService: NgbModal
    ) {
        this.const = CONSTANTS;
    }

    ngOnInit(): void {
        this.buildEuroStagesDictionary();
        this.loadData();
    } 

    getStageLabel(): string {
        return this.stages[this.stage];
    }

    doDraw() {
        this.drawingService.drawClubWcPlayoff(this.matchDay1, this.stage, this.drawingResult)
            .subscribe(result => {
                this.notificationService.showSuccess('Жеребьевка проведена!');
            }, error => {
                this.notificationService.showError('Ошибка жеребьевки');
            })
    }

    onChangeTeam(fixture: DrawingFixtureDto, isHomeTeam: boolean) {
        const modalRef = this.modalService.open(TeamShortModal);
        
        
         modalRef.componentInstance.team = isHomeTeam ? fixture.homeTeam : fixture.visitorTeam;
        
        modalRef.result.then((result) => {
            if (result) {
                if (isHomeTeam) {
                    fixture.homeTeam = result;
                } else {
                    fixture.visitorTeam = result;
                }
            }
        }, (reason) => { });
    }

    private loadData() {
        this.isLoading = true;

        this.drawingService.getClubWCPrePlayoffData(this.stage)
            .subscribe(result => {
                    this.drawingResult = result;
                    this.isLoading = false;
                }, 
                error =>  {
                    this.notificationService.showError('Не удалось загрузить данные.');
                    this.isLoading = false;
                }
            )
    }

    private buildEuroStagesDictionary() {
        this.stages = [];
        this.stages[CONSTANTS.euroCupStages.playoff8] = CONSTANTS.euroCupStagesNames.playoff8;
        this.stages[CONSTANTS.euroCupStages.playoff4] = CONSTANTS.euroCupStagesNames.playoff4;
        this.stages[CONSTANTS.euroCupStages.playoff2] = CONSTANTS.euroCupStagesNames.playoff2;
        this.stages[CONSTANTS.euroCupStages.final] = CONSTANTS.euroCupStagesNames.final;
    }
}